import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import { IcTranslate16Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView } from '@gem/ui-kit';

import styles from './styles.m.scss';

const Translate = ({ message, className }) => {
  const { t } = useTranslation();
  if (!message.hasTranslation) {
    return null;
  }

  let label = null;
  if (message.isLoadingTranslate) {
    label = t('common_loading');
  } else {
    if (message.isShowTranslate) {
      label = t('translated_label');
    }
  }

  return (
    <div className={classNames(styles.translate, className)}>
      <IconView
        Icon={IcTranslate16Icon}
        className={styles.icon}
        size={'small'}
      />
      {label ? <span className={styles.label}>{label}</span> : null}
      {!message.isLoadingTranslate && (
        <div
          role="button"
          tabIndex={0}
          onClick={message.toggleTranslate}
          className={styles.toggle}
        >
          {message.isShowTranslate ? t('show_original_button') : t('show_translation_button')}
        </div>
      )}
    </div>
  );
};

export default observer(Translate);
